import reducers from './reducers.js';

export default reducers;
